/* src/app/modules_v2/investment/financial-investment/components/financial-investment-detail/financial-investment-detail.component.scss */
:host {
  display: block;
}
.fid-panel {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(0, 1.4fr);
  gap: 16px;
}
.fid-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 0;
}
.fid-card__header,
.fid-block__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.fid-block__header {
  margin-bottom: 8px;
}
.fid-card__title,
.fid-block__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
  min-width: 0;
}
.fid-card__title mat-icon,
.fid-block__title mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
  flex-shrink: 0;
}
.fid-block__count {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.fid-progress__bar {
  height: 8px;
  border-radius: 999px;
  background: #eef1f4;
  overflow: hidden;
}
.fid-progress__fill {
  height: 100%;
  border-radius: 999px;
  background: #c5d94a;
  transition: width 0.3s ease;
}
.fid-progress__legend {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}
.fid-progress__legend strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.fid-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}
.fid-kpis--compact {
  margin-top: 8px;
}
.fid-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  background: #f4f6f8;
  border-radius: 8px;
  min-width: 0;
}
.fid-kpi--accent {
  background: #fbfee8;
  border: 1px solid #e5f3a0;
}
.fid-kpi__label {
  font-size: 11px;
  color: #6b7280;
}
.fid-kpi__value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fid-lines {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  border: 1px solid #eef1f4;
  border-radius: 8px;
  overflow: hidden;
}
.fid-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 12px;
  font-size: 13px;
  color: #2f3540;
}
.fid-line + .fid-line {
  border-top: 1px solid #eef1f4;
}
.fid-line__value {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.fid-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.fid-block {
  padding: 10px 0;
}
.fid-block + .fid-block {
  border-top: 1px solid #eef1f4;
}
.fid-block__side {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.fid-block__summary {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.fid-block__summary strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.fid-add.cf-btn.mat-mdc-button-base {
  height: 28px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
}
.fid-add.cf-btn.mat-mdc-button-base .mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  margin-right: 2px !important;
}
.fid-moves {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.fid-move {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  padding: 6px 6px 6px 10px;
  background: #f9fafb;
  border: 1px solid #eef1f4;
  border-radius: 6px;
  font-size: 13px;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.fid-move:hover {
  background: #fff;
  border-color: #e5e7eb;
}
.fid-move__date {
  color: #6b7280;
  white-space: nowrap;
}
.fid-move__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.fid-move__concept,
.fid-move__meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fid-move__concept {
  color: #2f3540;
}
.fid-move__meta {
  font-size: 11px;
  color: #6b7280;
}
.fid-move__amount {
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.fid-move__actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.fid-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.fid-icon-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.fid-icon-btn:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.fid-icon-btn--danger:hover {
  background: #fef2f2;
  color: #dc2626;
}
.fid-more {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 2px;
  margin-top: 2px;
  padding: 2px 6px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  cursor: pointer;
}
.fid-more mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.fid-more:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.fid-block__empty {
  font-size: 12px;
  color: #9ca3af;
  padding: 2px 0;
}
.fid-empty {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.fid-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.fid-empty--error mat-icon {
  color: #dc2626;
}
@media (max-width: 900px) {
  .fid-panel {
    grid-template-columns: 1fr;
  }
  .fid-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 480px) {
  .fid-move {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .fid-move__date {
    grid-column: 1/-1;
  }
}
.fid-card__header .fid-card__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fid-line__value {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 65%;
}
/*# sourceMappingURL=financial-investment-detail.component.css.map */
